import { createSlice } from '@reduxjs/toolkit';
import { logout } from './authSlice';

/**
 * Which account the top bar's picker is pointed at.
 *
 * Not persisted: a reload lands on a URL, and `?login=` there is what the
 * account-scoped pages read first.
 */
const initialState = {
  loginId: null,
  platform: null,
};

const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    selectAccount: (state, action) => {
      state.loginId = action.payload?.loginId ?? null;
      state.platform = action.payload?.platform ?? null;
    },
  },
  /**
   * Signing out — whether the trader asked or a 401 forced it — drops the
   * picked account with everything else. Whoever signs in next on this browser
   * must not inherit a picker aimed at someone else's login.
   */
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState);
  },
});

export const { selectAccount } = accountSlice.actions;

export const selectPickedAccount = (state) => state.account;

export default accountSlice.reducer;
